import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n'
import { initialize } from './common/logging/init-sentry'

initialize()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />)
